import { useLoading, MatchUp, createCssVariableString, Modal, Button, Typography } from "best-common-react";
import React, { useState } from "react";
import styled from "styled-components";
import { DayOfGameDTO } from "../../types/TodaysTickets";
import { useTimezone } from "../../util/TimeUtil";
import TodaysTicketsGameRequest from "./TodaysTicketsGameRequest";

type StyleProps = {
  isActive: boolean;
};

const Container = styled.div<StyleProps>`
  padding: 1rem;
  border: 1px solid ${createCssVariableString("outlineColorsOutlineVariant")};
  border-radius: 4px;
  background: ${(props) =>
    props.isActive
      ? createCssVariableString("surfaceColorsSurfaceContainerLow")
      : createCssVariableString("surfaceColorsSurfaceContainerLowest")};
  &:hover {
    cursor: ${(props) => (props.isActive ? "pointer" : "not-allowed")};
  }
`;

const Game = styled.div`
  display: flex;
  justify-content: space-between;
`;

const GameInformation = styled.div`
  display: flex;
  flex-direction: column;
`;

const Description = styled.div`
  font-size: 0.875rem;

  margin-top: 1rem;
  font-weight: bold;
  display: flex;
`;

const Header = styled.div`
  font-size: 1.125rem;
  font-weight: bold;
`;

const VenueName = styled.div`
  margin-top: 0.5rem;
`;

const TicketDescription = styled.div`
  margin-top: 0.5rem;
`;

type DayOfGameProps = {
  game: DayOfGameDTO;
  refreshData?: () => void;
  allotment?: number;
  isLotto?: boolean;
  canRequestTickets?: boolean;
};

const TodaysTicketsGame: React.FC<DayOfGameProps> = ({
  game,
  refreshData,
  allotment,
  isLotto = false,
  canRequestTickets = true,
}) => {
  const { setLoading } = useLoading();
  const [requestOpen, setRequestOpen] = useState<boolean>(false);
  const [cannotRequestOpen, setCannotRequestOpen] = useState<boolean>(false);
  const tz = game.venue ? game.venue.timeZone : null;
  const { time, day, date } = useTimezone(game.gameDate, tz, {
    startTimeTBD: false,
    statusCode: "",
    detailedState: "",
    codedGameState: "",
    abstractGameState: "",
    abstractGameCode: "",
  });
  const teamId: number = game.home.id;
  const allowedToRequest: boolean = game.ticketsLeft > 0 && allotment > 0;

  return (
    <>
      <Modal show={cannotRequestOpen} size="md">
        <Modal.Header close={() => setCannotRequestOpen(false)}>Ticket Claim Restriction</Modal.Header>
        <Modal.Body>
          <Typography>
            You currently hold approved tickets for the selected game. To ensure equitable distribution, additional
            ticket requests for this event cannot be processed at this time.
          </Typography>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setCannotRequestOpen(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
      <TodaysTicketsGameRequest
        isOpen={requestOpen}
        onSave={!!refreshData ? refreshData : () => {}}
        onClose={() => setRequestOpen(false)}
        gamePk={game.gamePk}
        teamId={teamId}
        ticketsLeft={game.ticketsLeft}
        allotment={allotment}
        isLotto={isLotto}
      />
      <Container
        isActive={allowedToRequest}
        onClick={() => {
          if (!canRequestTickets) {
            setCannotRequestOpen(true);
          } else if (allowedToRequest) {
            setCannotRequestOpen(false);
            setLoading(true);
            setRequestOpen(true);
          }
        }}
      >
        <Game>
          <GameInformation>
            <div>
              <Header>{date}</Header>
              <Description>
                {day}
                <Game className="bcr-ms-2">{time}</Game>
              </Description>
            </div>
          </GameInformation>
          <div>
            <MatchUp home={game.home} away={game.away} />
          </div>
        </Game>
        <VenueName>{game.venue.name}</VenueName>
        {game.ticketsLeft !== undefined && <TicketDescription>{game.ticketsLeft} Ticket(s) Left</TicketDescription>}
      </Container>
    </>
  );
};

export default TodaysTicketsGame;
